import { Injectable } from '@angular/core';
import { CidadeEntity } from '@domain/dto/cidade/cidade-get.dto';
import { ApiSecundariaUsecase } from '@domain/usecases/api-secundaria-usecase.ts/api-secundaria-usecase';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiSecundariaController {
  constructor(private usecaseService: ApiSecundariaUsecase) {}

  getApiSecundaria(): Observable<any> {
    return this.usecaseService.getApiSecundaria();
  }
}
